/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.11",
    versionName: "0.2.0-nightly.2026.2.11",
    versionChannel: "nightly",
    buildDate: "2026-02-11T00:16:27.244Z",
    commitHash: "2bc90d0082a3b891eeb15553a502e3e83ad096cb",
};
